import { NativeSelect, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

export const MultiLevelCombobox = ({
  value,
  customInput,
  onChange,
  isDisabled,
}: {
  value: any;
  customInput: any;
  onChange: (value: any) => void;
  isDisabled?: boolean;
}) => {
  const intl = useIntl();
  const [data, setData] = useState<any>({
    ...customInput,
    selectedValues: Object.keys(customInput.selectedValues)
      .map((key: any) => {
        return {
          [key]: value?.[key] || '',
        };
      })
      .reduce((acc, obj) => ({ ...acc, ...obj }), {}),
    properties: Object.keys(customInput.properties)
      .map((key: any) => {
        return {
          [key]: value?.[key] || '',
        };
      })
      .reduce((acc, obj) => ({ ...acc, ...obj }), {}),
  });

  const keys = Object.keys(data.selectedValues);

  useEffect(() => {
    const combinedValue = {
      ...data.selectedValues,
      ...data.properties,
    };
    onChange(combinedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Stack gap="md">
      {keys.map((key: string, keyIndex: number) => (
        <NativeSelect
          disabled={isDisabled}
          key={keyIndex}
          label={customInput.selectedValuesLabels?.[key] || key}
          value={data.selectedValues[key]}
          onChange={(event) => {
            const _value = event.currentTarget.value;
            const newSelectedValues = { ...data.selectedValues };

            newSelectedValues[key] = _value;

            for (let i = keyIndex + 1; i < keys.length; i++) {
              newSelectedValues[keys[i]] = '';
            }

            setData({
              ...data,
              selectedValues: newSelectedValues,
              ...(keyIndex === keys.length - 1
                ? {
                    properties: {
                      ...Object.keys(data.properties).reduce((acc, propKey) => {
                        const matchedEntry = data.values.find(
                          (item: any) => item[key] === _value
                        );
                        return {
                          ...acc,
                          [propKey]: matchedEntry?.[propKey] || '',
                        };
                      }, {}),
                    },
                  }
                : {
                    properties: {
                      ...Object.keys(data.properties)
                        .map((dep) => ({
                          [dep]: '',
                        }))
                        .reduce((acc, obj) => ({ ...acc, ...obj }), {}),
                    },
                  }),
            });
          }}
          data={[
            { value: '', label: `${intl.formatMessage({ id: 'select' })}...` },
            ...data.values
              .filter((item: any) =>
                keyIndex > 0
                  ? item[keys[keyIndex - 1]] ===
                    data.selectedValues[keys[keyIndex - 1]]
                  : true
              )
              .map((item: any) => item[key])
              .filter(
                (value: any, index: number, array: any[]) =>
                  array.indexOf(value) === index
              )
              .sort((a: string, b: string) => {
                if (!a) return 1;
                if (!b) return -1;
                return a.localeCompare(b, undefined, { sensitivity: 'base' });
              })
              .map((_value: any) => ({
                value: _value,
                label: _value,
              })),
          ]}
        />
      ))}
    </Stack>
  );
};
